import React from 'react';
import { IMAGES } from '../constants/images';
import { ROUTES } from '../App';
import useMoveTo from '../constants/navigation';

const GuestHeader = () => {
    const navigate = useMoveTo();

    return (
        <header className="hidden md:flex items-center justify-between py-4 px-8 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-[#1A1A1A] sticky top-0 z-50">
            {/* Logo */}
            <div 
                className="cursor-pointer flex items-center" 
                onClick={() => navigate(ROUTES.PREVIEW_STORE)}
            >
                <img 
                    src={IMAGES.dashboardLogo} 
                    alt="Zylen" 
                    className="h-8 brightness-0 dark:invert" 
                />
            </div>

            {/* Actions */}
            <div className="flex items-center gap-4">
                <button
                    onClick={() => navigate(ROUTES.SIGN_IN)}
                    className="px-6 py-2 rounded-xl font-semibold transition border border-[#327691] text-[#327691] hover:bg-[#327691] hover:text-white"
                >
                    Log In
                </button>
                <button
                    onClick={() => navigate(ROUTES.SIGN_UP)}
                    className="px-6 py-2 rounded-xl font-semibold transition bg-[#327691] text-white hover:bg-[#2a637a]"
                >
                    Sign Up
                </button>
            </div>
        </header>
    );
};

export default GuestHeader;
